// Events for amplitude tracking
export enum AnnouncementTrackingEvent {
	// User interaction
	AnnouncementCarouselInteraction = 'Announcement Carousel Interaction',

	// Create
	GiveboxAnnouncementButtonClicked = 'Givebox Announcement Button Clicked',
	MakeAnnouncementModalViewed = 'Make Announcement Modal Viewed',
	MakeAnnouncementModalClosed = 'Make Announcement Modal Closed',
	CreateAnnouncementRequestSubmitted = 'Create Announcement Request Submitted',
	CreateAnnouncementSuccess = 'Create Announcement Success',
	CreateAnnouncementFailure = 'Create Announcement Failure',

	// Edit
	EditAnnouncementButtonClicked = 'Edit Announcement Button Clicked',
	EditAnnouncementModalViewed = 'Edit Announcement Modal Viewed',
	EditAnnouncementModalClosed = 'Edit Announcement Modal Closed',
	ManageAnnouncementsButtonClicked = 'Manage Announcements Button Clicked',
	ManageAnnouncementsModalViewed = 'Manage Announcements Modal Viewed',
	ManageAnnouncementsModalClosed = 'Manage Announcements Modal Closed',
	UpdateAnnouncementRequestSubmitted = 'Update Announcement Request Submitted',
	UpdateAnnouncementSuccess = 'Update Announcement Success',
	UpdateAnnouncementFailure = 'Update Announcement Failure',

	// View
	ViewAnnouncementModalViewed = 'View Announcement Modal Viewed',
	ViewAnnouncementModalClosed = 'View Announcement Modal Closed',

	// Claim Incentive
	AnnouncementClaimIncentiveButtonClicked = 'Announcement Claim Incentive Button Clicked',
	ClaimIncentiveModalViewed = 'Claim Incentive Modal Viewed',
	ClaimIncentiveModalClosed = 'Claim Incentive Modal Closed',
	ClaimIncentiveRequestSubmitted = 'Claim Incentive Request Submitted',
	ClaimIncentiveSuccess = 'Claim Incentive Success',
	ClaimIncentiveFailure = 'Claim Incentive Failure',
}

export enum AnnouncementActionEvent {
	OpenAnnouncement = 'open-announcement',
}

export interface OpenAnnouncementEvent {
	id?: string;
}

export enum Variant {
	MsTeams2025 = 'ms-teams-2025',
}
